import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { inject as service } from '@ember/service';
import { memberAction } from 'ember-api-actions';
import _cloneDeep from 'lodash/cloneDeep';

export default class MailerTemplateVersion extends Model {
  @service state;

  @belongsTo('mailer-template') mailerTemplate;

  @hasMany('mailer-section-block-override') mailerSectionBlockOverrides;
  @hasMany('location') locations;
  @hasMany('company') companies;
  @hasMany('flow') flows;

  @attr('string') title;
  @attr('boolean', { defaultValue: false }) isDefault;

  serializeWithBlockOverrides() {
    const { currentCompany, currentLocation } = this.state;
    const serializedOverrides = this.mailerSectionBlockOverrides.map((override) => override.serialize().data);
    const payload = this.serialize();
    payload.meta = {
      ...(payload.meta || {}),
      location_id: currentLocation.id,
      company_id: currentCompany.id,
    };
    payload.data.relationships = {
      ...(payload.data.relationships || {}),
      'mailer-section-block-overrides': {
        data: serializedOverrides,
      },
    };
    return payload;
  }

  async sendTestEmail() {}
  async getEmailPreview() {}
}

MailerTemplateVersion.prototype.sendTestEmail = memberAction({
  path: 'send-test',
  type: 'PATCH',
  before() {
    return this.serializeWithBlockOverrides();
  },
});

MailerTemplateVersion.prototype.getEmailPreview = memberAction({
  path: 'preview',
  type: 'PATCH',
  before() {
    return this.serializeWithBlockOverrides();
  },
});
